(function () {
  function setSelected(root, selector, target) {
    root.querySelectorAll(selector).forEach(function (item) {
      item.setAttribute('aria-selected', item === target ? 'true' : 'false');
      item.tabIndex = item === target ? 0 : -1;
    });
  }

  function selectFaqCategory(button) {
    var faq = button.closest('[data-nexbie-faq]');
    var category = button.getAttribute('data-faq-category');
    setSelected(faq, '[data-faq-category]', button);
    faq.querySelectorAll('[data-faq-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-faq-panel') !== category;
    });
    if (window.matchMedia('(max-width: 768px)').matches) {
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function setFaqAnswerState(trigger, answer, expand) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var answerContent = answer.querySelector('.nexbie-faq__answer-content');
    trigger.setAttribute('aria-expanded', expand ? 'true' : 'false');

    if (answer._nexbieFaqTransitionCleanup) answer._nexbieFaqTransitionCleanup();
    if (answer._nexbieFaqAnimationFrame) cancelAnimationFrame(answer._nexbieFaqAnimationFrame);

    if (reduceMotion) {
      answer.hidden = !expand;
      answer.style.height = '';
      return;
    }

    if (expand) {
      answer.hidden = false;
      answer.style.height = '0px';
      var expandedHeight = answerContent.scrollHeight;
    } else {
      // The outer animation wrapper no longer has padding, so its rendered
      // height is the exact visible answer height at the start of collapse.
      var collapsedHeight = answer.getBoundingClientRect().height;
      answer.style.height = collapsedHeight + 'px';
    }
    answer.classList.add('is-animating');

    var complete = function (event) {
      if (event && (event.target !== answer || event.propertyName !== 'height')) return;
      answer.removeEventListener('transitionend', complete);
      answer._nexbieFaqTransitionCleanup = null;
      answer._nexbieFaqAnimationFrame = null;
      answer.classList.remove('is-animating');
      answer.style.height = '';
      if (!expand) answer.hidden = true;
    };
    answer._nexbieFaqTransitionCleanup = function () {
      answer.removeEventListener('transitionend', complete);
      answer.classList.remove('is-animating');
      answer._nexbieFaqTransitionCleanup = null;
    };
    answer.addEventListener('transitionend', complete);
    answer._nexbieFaqAnimationFrame = requestAnimationFrame(function () {
      answer.style.height = expand ? expandedHeight + 'px' : '0px';
    });
  }

  document.addEventListener('click', function (event) {
    var faqCategory = event.target.closest('[data-faq-category]');
    if (faqCategory) {
      selectFaqCategory(faqCategory);
      return;
    }

    var faqTrigger = event.target.closest('[data-faq-trigger]');
    if (faqTrigger) {
      var expanded = faqTrigger.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(faqTrigger.getAttribute('aria-controls'));
      setFaqAnswerState(faqTrigger, answer, !expanded);
      return;
    }

    var certificationTab = event.target.closest('[data-certification-tab]');
    if (certificationTab) {
      var certification = certificationTab.closest('[data-nexbie-certification]');
      var tab = certificationTab.getAttribute('data-certification-tab');
      setSelected(certification, '[data-certification-tab]', certificationTab);
      certification.querySelectorAll('[data-certification-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-certification-panel') !== tab;
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    var category = event.target.closest('[data-faq-category]');
    if (!category || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    var categories = Array.prototype.slice.call(category.closest('[data-nexbie-faq]').querySelectorAll('[data-faq-category]'));
    var index = categories.indexOf(category);
    if (event.key === 'ArrowLeft') index = (index - 1 + categories.length) % categories.length;
    if (event.key === 'ArrowRight') index = (index + 1) % categories.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = categories.length - 1;
    event.preventDefault();
    categories[index].focus();
    selectFaqCategory(categories[index]);
  });
})();
